import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";

const MegaMenuMobile = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  return (
    <div className="mega-menu-wrapper">
      <div className="mega-swicher"></div>
      <div className="mob-header multi-mob-header">
        <button className="toggler-menu" onClick={handleClick}>
          <div className={click ? "active" : ""}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </div>
      {/* End Header */}

      <Sidebar
        className={click ? "mega-mobile-menu menu-open" : "mega-mobile-menu"}
        toggled={click}
        onBackdropClick={handleClick}
        breakPoint="all"
      >
        <div style={{ padding: "20px" }}>
          <div className="logo position-static">
            <a href="/">
              <img src="/images/logo/gotong-royong-50.png" alt="home-demo" />
            </a>
          </div>
          <div className="fix-icon text-dark" onClick={handleClick}>
            <img src="images/icon/close-w.svg" alt="icon" />
          </div>
          {/* Mobile Menu close icon */}
        </div>
        <Menu>
          <MenuItem component={<Link to="/" onClick={handleClick} />}>Home</MenuItem>
          <MenuItem component={<Link to="/login" onClick={handleClick} />}>Login</MenuItem>
          <MenuItem component={<Link to="/signup" onClick={handleClick} />}>Sign Up</MenuItem>
          <MenuItem component={<Link to="/terms-conditions" onClick={handleClick} />}>
            Terms & Conditions
          </MenuItem>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default MegaMenuMobile;
